export default __webpack_public_path__ + "static/media/six_.dc934f5f.jpeg";